import { firebase } from "@firebase/app";
import "firebase/auth";
const { firebaseConfig } = require("../config/firebaseConfig");
firebase.initializeApp(firebaseConfig);
const Provider = new firebase.auth.GoogleAuthProvider();
const FirebaseAuth = firebase.auth;

export { FirebaseAuth, Provider };
